import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';

import * as styles from '../../styles';
import Tree from '../tree';
import Content from '../../content-manager/content';
import {request} from '../../containers/actions';

//Radium(NoteForm);
export default class NoteForm extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
        user: PropTypes.object,
    }

    static defaultProps = {
        onFinished: _.identity,
    }

    state = {
        body: '',
        subject: '',
    }

    async submit() {
        if (!this.state.subject || this.props.noteTypeTree.get('selected').size === 0 || !this.state.body)
            return;
        await this.context.store.dispatch(request({
            path: '/note/',
            method: 'POST',
            body: {
                subject: this.state.subject,
                type: {id: this.props.noteTypeTree.get('selected').keySeq().first()},
                body: this.state.body,
                chapter: {id: this.props.chapter},
                ...(this.context.user.hasPerm('book.note') ? {confirmed_body: this.state.body} : {}),
            },
        }));
        this.setState({body: ''});
        this.props.onFinished();
    }

    render() {
        return <div style={{display: 'inline-block', width: '100%'}}>
            <div
                style={{
                    float: 'right',
                    clear: 'right',
                    width: 'calc(100% / 2 - 1em)',
                    marginLeft: '.5em',
                    marginRight: '.5em',
                }}>
                <input
                    key='subject'
                    style={{
                        ...styles.field,
                        border: this.state.subject
                            ? styles.field.border
                            : `.0625em solid ${styles.alertColor}`,
                        backgroundColor: this.state.subject
                            ? styles.input.backgroundColor
                            : styles.alertBackColor,
                    }}
                    placeholder={window.pgettext('note', 'Subject')}
                    value={(this.state.subject || '').persian()}
                    onChange={({target: {value}}) => this.setState({subject: value})}
                />
            </div>
            <div
                style={{
                    float: 'right',
                    width: 'calc(100% / 2 - 1em)',
                    marginLeft: '.5em',
                    marginRight: '.5em',
                    marginBottom: '1em',
                    fontSize: '.9em',
                }}>
                <Tree
                    store={this.props.noteTypeTree}
                    readonly={!this.context.user.hasPerm('book.note')}
                    resource='note-type'
                    multiSelection={false}
                    combobox
                    label={window.pgettext('note', 'Type')}
                    itemLabel='label'
                    style={{
                        border: this.props.noteTypeTree.get('selected').size > 0
                            ? undefined
                            : `.0625em solid ${styles.alertColor}`,
                        backgroundColor: this.props.noteTypeTree.get('selected').size > 0
                            ? undefined
                            : styles.alertBackColor,
                    }}
                />
            </div>
            <div
                style={{
                    float: 'right',
                    clear: 'right',
                    width: 'calc(100% - 1em)',
                    marginLeft: '.5em',
                    marginRight: '.5em',
                }}>
                <Content
                    inline
                    content={(this.state.body || '')}
                    style={{
                        ...styles.field,
                        height: undefined,
                        minHeight: '5em',
                        border: this.state.bodyText
                            ? styles.field.border
                            : `.0625em solid ${styles.alertColor}`,
                        backgroundColor: this.state.bodyText
                            ? ''
                            : styles.alertBackColor,
                    }}
                    onChange={(body, bodyText) => this.setState({body, bodyText: bodyText.trim()})}
                />
            </div>
            <button
                style={{
                    ...styles.defaultButton,
                    clear: 'left',
                    float: 'left',
                    marginTop: '.5em',
                    marginLeft: '.5em',
                    marginRight: '.5em',
                }}
                onClick={this.submit.bind(this)}>
                {window.gettext('Submit')}
            </button>
            <button
                style={{
                    ...styles.button,
                    float: 'left',
                    marginTop: '.5em',
                    marginRight: '.5em',
                }}
                onClick={this.props.onFinished}>
                {window.gettext('Cancel')}
            </button>
        </div>;
    }
}
